import { componentQrl, inlinedQrl, useStore, _jsxC, _IMMUTABLE, _fnSignal } from "@builder.io/qwik";
import { InlinedStyles } from "../../inlined-styles.qwik.mjs";
import { getCss, getFontCss, getDefaultStyles } from "./styles.helpers.qwik.mjs";
const ContentStyles = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  const state = useStore({
    injectedStyles: `
${getCss({
      cssCode: props.cssCode,
      contentId: props.contentId
    })}
${getFontCss({
      customFonts: props.customFonts
    })}
${getDefaultStyles(props.isNestedRender)}
`.trim()
  });
  return /* @__PURE__ */ _jsxC(InlinedStyles, {
    id: "builderio-content",
    get styles() {
      return state.injectedStyles;
    },
    get nonce() {
      return props.nonce;
    },
    [_IMMUTABLE]: {
      id: _IMMUTABLE,
      nonce: _fnSignal((p0) => p0.nonce, [
        props
      ], "p0.nonce"),
      styles: _fnSignal((p0) => p0.injectedStyles, [
        state
      ], "p0.injectedStyles")
    }
  }, 3, "8O_0");
}, "ContentStyles_component_Qbhu1myPWm0"));
export {
  ContentStyles,
  ContentStyles as default
};
